export default class Menu {
  constructor() {
    this.hamburger = $(".hamburger__wrapper")
    this.nav = $(".header__nav")

    this.navItem = $(".primary-nav > li > a")
    this.childrenToggle = $(".children-toggle")

    this.initMenu()
    this.initChildrenToggle()
  }

  initMenu() {
    this.hamburger.on("click", () => {
      this.hamburger.children().toggleClass("active")
      this.nav.slideToggle(300)
    })

    this.navItem.on("focus", () => {
      this.childrenToggle.removeClass("open")

      this.childrenToggle.each((_, element) => {
        const $toggle = $(element)

        if ($toggle.hasClass("open")) {
          $toggle.attr("aria-label", "Hide Children")
        } else {
          $toggle.attr("aria-label", "Show Children")
        }
      })
    })
  }

  initChildrenToggle() {
    this.childrenToggle.on("click", (e) => {
      const $toggle = $(e.currentTarget)

      $toggle.toggleClass("open")

      if (window.innerWidth < 960) {
        $toggle.next().slideToggle(300)
      }

      if ($toggle.hasClass("open")) {
        $toggle.attr("aria-label", "Hide Children")
      } else {
        $toggle.attr("aria-label", "Show Children")
      }
    })
  }
}
